export default __webpack_public_path__ + "static/media/icon_enterprise_news.0c4895ff.webp";